// src/lib/translations.ts

export const translations = {
  gameOverview: {
    title: {
      en: "overview",
      ja: "概要",
      ko: "개요",
      th: "ภาพรวม",
      es: "resumen",
      ru: "обзор",
      vi: "tổng quan",
      kk: "шолу",
      id: "ikhtisar",
      de: "Übersicht"
    },
    whyPlay: {
      en: "Why Play",
      ja: "なぜプレイするのか",
      ko: "왜 플레이해야 하나요",
      th: "ทำไมต้องเล่น",
      es: "Por qué jugar",
      ru: "Почему стоит играть",
      vi: "Tại sao chơi",
      kk: "Неге ойнау керек",
      id: "Mengapa bermain",
      de: "Warum spielen"
    }
  },
  gameplayGuide: {
    title: {
      en: "How to play",
      ja: "遊び方",
      ko: "게임 방법",
      th: "วิธีการเล่น",
      es: "Cómo jugar",
      ru: "Как играть",
      vi: "Cách chơi",
      kk: "Қалай ойнау керек",
      id: "Cara bermain",
      de: "Spielanleitung"
    },
    removeBlocks: {
      en: "Miside",
      ja: "Miside",
      ko: "Miside",
      th: "Miside",
      es: "Miside",
      ru: "Miside",
      vi: "Miside",
      kk: "Miside",
      id: "Miside",
      de: "Miside"
    }
  },
  scoringSystem: {
    title: {
      en: "How to calculate points",
      ja: "ポイントの計算方法",
      ko: "점수 계산 방법",
      th: "วิธีคำนวณคะแนน",
      es: "Cómo calcular puntos",
      ru: "Как подсчитать очки",
      vi: "Cách tính điểm",
      kk: "Ұпай есептеу",
      id: "Cara menghitung poin",
      de: "Punkteberechnung"
    },
    basicScore: {
      en: "Basic score",
      ja: "基本スコア",
      ko: "기본 점수",
      th: "คะแนนพื้นฐาน",
      es: "Puntuación básica",
      ru: "Базовые очки",
      vi: "Điểm cơ bản",
      kk: "Негізгі ұпай",
      id: "Skor dasar",
      de: "Grundpunktzahl"
    }
  },
  tutorials: {
    title: {
      en: "Tutorial Videos from Youtube",
      ja: "YouTubeのチュートリアル動画",
      ko: "YouTube 튜토리얼 동영상",
      th: "วิดีโอสอนจาก Youtube",
      es: "Videos tutoriales de Youtube",
      ru: "Обучающие видео с Youtube",
      vi: "Video hướng dẫn từ Youtube",
      kk: "Youtube-тен оқу видеолары",
      id: "Video Tutorial dari Youtube",
      de: "Tutorial-Videos von Youtube"
    }
  },
  comments: {
    title: {
      en: "Comments",
      ja: "コメント",
      ko: "댓글",
      th: "ความคิดเห็น",
      es: "Comentarios",
      ru: "Комментарии",
      vi: "Bình luận",
      kk: "Пікірлер",
      id: "Komentar",
      de: "Kommentare"
    },
    placeholders: {
      name: {
        en: 'Your name',
        ja: 'お名前',
        ko: '이름',
        th: 'ชื่อของคุณ',
        es: 'Tu nombre',
        ru: 'Ваше имя',
        vi: 'Tên của bạn',
        kk: 'Сіздің атыңыз',
        id: 'Nama Anda',
        de: 'Ihr Name'
      },
      content: {
        en: 'Write a comment...',
        ja: 'コメントを書く...',
        ko: '댓글을 작성하세요...',
        th: 'เขียนความคิดเห็น...',
        es: 'Escribe un comentario...',
        ru: 'Написать комментарий...',
        vi: 'Viết bình luận...',
        kk: 'Пікір жазыңыз...',
        id: 'Tulis komentar...',
        de: 'Schreiben Sie einen Kommentar...'
      }
    },
    noComments: {
      en: "No comments yet. Be the first to comment!",
      ja: "まだコメントはありません。最初のコメントを投稿しましょう！",
      ko: "아직 댓글이 없습니다. 첫 댓글을 남겨보세요!",
      th: "ยังไม่มีความคิดเห็น เป็นคนแรกที่แสดงความคิดเห็น!",
      es: "Aún no hay comentarios. ¡Sé el primero en comentar!",
      ru: "Пока нет комментариев. Будьте первым, кто прокомментирует!",
      vi: "Chưa có bình luận nào. Hãy là người đầu tiên bình luận!",
      kk: "Әзірше пікірлер жоқ. Бірінші болып пікір қалдырыңыз!",
      id: "Belum ada komentar. Jadilah yang pertama berkomentar!",
      de: "Noch keine Kommentare. Seien Sie der Erste, der kommentiert!"
    },
    sortBy: {
      newest: {
        en: "Newest",
        ja: "最新",
        ko: "최신순",
        th: "ใหม่ล่าสุด",
        es: "Más recientes",
        ru: "Новейшие",
        vi: "Mới nhất",
        kk: "Ең жаңа",
        id: "Terbaru",
        de: "Neueste"
      },
      oldest: {
        en: "Oldest",
        ja: "最古",
        ko: "오래된순",
        th: "เก่าที่สุด",
        es: "Más antiguos",
        ru: "Старейшие",
        vi: "Cũ nhất",
        kk: "Ең ескі",
        id: "Terlama",
        de: "Älteste"
      }
    },
    submitButton: {
      en: 'Submit Comment',
      ja: 'コメントを投稿',
      ko: '댓글 작성',
      th: 'ส่งความคิดเห็น',
      es: 'Enviar comentario',
      ru: 'Отправить комментарий',
      vi: 'Gửi bình luận',
      kk: 'Пікір жіберу',
      id: 'Kirim Komentar',
      de: 'Kommentar absenden'
    }
  },
  footer: {
    about: {
      title: {
        en: "About",
        ja: "について",
        ko: "소개",
        th: "เกี่ยวกับ",
        es: "Acerca de",
        ru: "О нас",
        vi: "Giới thiệu",
        kk: "Туралы",
        id: "Tentang",
        de: "Über uns"
      },
      description: {
        en: 'Discover Miside, an immersive psychological horror game where reality blends with digital worlds. Meet Mita and uncover dark secrets in this haunting adventure.',
        ja: '現実とデジタル世界が融合する没入型サイコホラーゲームMisideを体験。ミタと出会い、暗い秘密を解き明かそう。',
        ko: '현실과 디지털 세계가 융합되는 몰입형 심리 공포 게임 Miside를 발견하세요. 미타를 만나고 어두운 비밀을 밝혀보세요.',
        th: 'ค้นพบ Miside เกมสยองขวัญเชิงจิตวิทยาที่ผสานโลกแห่งความจริงกับโลกดิจิทัล พบกับ Mita และไขปริศนาความลับอันน่าสะพรึงกลัว.',
        es: 'Descubre Miside, un juego de terror psicológico inmersivo donde la realidad se mezcla con mundos digitales. Conoce a Mita y descubre secretos oscuros.',
        ru: 'Откройте Miside, иммерсивную психологическую игру ужасов, где реальность сливается с цифровыми мирами. Встретьте Миту и раскройте тёмные тайны.',
        vi: 'Khám phá Miside, game kinh dị tâm lý nơi thực tại hòa quyện với thế giới số. Gặp gỡ Mita và khám phá những bí mật đen tối.',
        kk: 'Қарапайым сыртқы келбетінің астында, MiSide біртіндеп пайда болатын қараңғы құпияларды жасырып, тәжірибені әлдеқайда қорқынышты нәрсеге айналдырады!',
        id: 'Temukan Miside, game horror psikologis yang memadukan dunia nyata dengan dunia digital. Temui Mita dan ungkap rahasia gelap dalam petualangan mengerikan ini.',
        de: 'Entdecke Miside, ein immersives psychologisches Horrorspiel, in dem die Realität mit digitalen Welten verschmilzt. Triff Mita und decke dunkle Geheimnisse in diesem unheimlichen Abenteuer auf.'
      }
    },
    quickLinks: {
      title: {
        en: "Quick Links",
        ja: "クイックリンク",
        ko: "빠른 링크",
        th: "ลิงก์ด่วน",
        es: "Enlaces rápidos",
        ru: "Быстрые ссылки",
        vi: "Liên kết nhanh",
        kk: "Жылдам сілтемелер",
        id: "Tautan Cepat",
        de: "Schnelllinks"
      },
      home: {
        en: "Home",
        ja: "ホーム",
        ko: "홈",
        th: "หน้าแรก",
        es: "Inicio",
        ru: "Главная",
        vi: "Trang chủ",
        kk: "Басты бет",
        id: "Beranda",
        de: "Startseite"
      },
      playNow: {
        en: "Play Now",
        ja: "今すぐプレイ",
        ko: "지금 플레이",
        th: "เล่นเลย",
        es: "Jugar ahora",
        ru: "Играть сейчас",
        vi: "Chơi ngay",
        kk: "Қазір ойнау",
        id: "Main Sekarang",
        de: "Jetzt spielen"
      },
      tutorials: {
        en: "Tutorials",
        ja: "チュートリアル",
        ko: "튜토리얼",
        th: "บทเรียน",
        es: "Tutoriales",
        ru: "Учебники",
        vi: "Hướng dẫn",
        kk: "Оқулықтар",
        id: "Tutorial",
        de: "Tutorials"
      },
      popularGames: {
        en: "Popular Games",
        ja: "人気ゲーム",
        ko: "인기 게임",
        th: "เกมยอดนิยม",
        es: "Juegos populares",
        ru: "Популярные игры",
        vi: "Trò chơi phổ biến",
        kk: "Танымал ойындар",
        id: "Game Populer",
        de: "Beliebte Spiele"
      }
    },
    community: {
      title: {
        en: "Community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        th: "ชุมชน",
        es: "Comunidad",
        ru: "Сообщество",
        vi: "Cộng đồng",
        kk: "Қауымдастық",
        id: "Komunitas",
        de: "Community"
      },
      discord: {
        en: "Discord",
        ja: "Discord",
        ko: "Discord",
        th: "Discord",
        es: "Discord",
        ru: "Discord",
        vi: "Discord",
        kk: "Discord",
        id: "Discord",
        de: "Discord"
      },
      facebook: {
        en: "Facebook",
        ja: "Facebook",
        ko: "Facebook",
        th: "Facebook",
        es: "Facebook",
        ru: "Facebook",
        vi: "Facebook",
        kk: "Facebook",
        id: "Facebook",
        de: "Facebook"
      },
      twitter: {
        en: "Twitter",
        ja: "Twitter",
        ko: "Twitter",
        th: "Twitter",
        es: "Twitter",
        ru: "Twitter",
        vi: "Twitter",
        kk: "Twitter",
        id: "Twitter",
        de: "Twitter"
      },
      youtube: {
        en: "YouTube",
        ja: "YouTube",
        ko: "YouTube",
        th: "YouTube",
        es: "YouTube",
        ru: "YouTube",
        vi: "YouTube",
        kk: "YouTube",
        id: "YouTube",
        de: "YouTube"
      }
    },
    contact: {
      title: {
        en: "Contact Us",
        ja: "お問い合わせ",
        ko: "문의하기",
        th: "ติดต่อเรา",
        es: "Contáctenos",
        ru: "Свяжитесь с нами",
        vi: "Liên hệ",
        kk: "Байланыс",
        id: "Hubungi Kami",
        de: "Kontakt"
      },
      email: {
        en: "support@miside.world",
        ja: "support@miside.world",
        ko: "support@miside.world",
        th: "support@miside.world",
        es: "support@miside.world",
        ru: "support@miside.world",
        vi: "support@miside.world",
        kk: "support@miside.world",
        id: "support@miside.world",
        de: "support@miside.world"
      },
      address: {
        en: "123 Game Street, Tokyo, Japan",
        ja: "〒123-4567 東京都渋谷区ゲーム通り1-2-3",
        ko: "123 게임 스트리트, 도쿄, 일본",
        th: "123 ถนนเกม โตเกียว ญี่ปุ่น",
        es: "123 Calle del Juego, Tokio, Japón",
        ru: "123 Улица Игр, Токио, Япония",
        vi: "123 Đường Game, Tokyo, Nhật Bản",
        kk: "123 Гейм көшесі, Токио, Жапония",
        id: "123 Jalan Game, Tokyo, Jepang",
        de: "123 Spielstraße, Tokio, Japan"
      }
    },
    links: {
      privacy: {
        en: 'Privacy Policy',
        ja: 'プライバシーポリシー',
        ko: '개인정보 처리방침',
        th: 'นโยบายความเป็นส่วนตัว',
        es: 'Política de privacidad',
        ru: 'Политика конфиденциальности',
        vi: 'Chính sách bảo mật',
        kk: 'Құпиялылық саясаты',
        id: 'Kebijakan Privasi',
        de: 'Datenschutzerklärung'
      },
      terms: {
        en: 'Terms of Service',
        ja: '利用規約',
        ko: '이용약관',
        th: 'ข้อกำหนดการใช้งาน',
        es: 'Términos de servicio',
        ru: 'Условия использования',
        vi: 'Điều khoản dịch vụ',
        kk: 'Қызмет көрсету шарттары',
        id: 'Ketentuan Layanan',
        de: 'Nutzungsbedingungen'
      },
      cookies: {
        en: 'Cookie Policy',
        ja: 'Cookie ポリシー',
        ko: '쿠키 정책',
        th: 'นโยบายคุกกี้',
        es: 'Política de cookies',
        ru: 'Политика использования файлов cookie',
        vi: 'Chính sách cookie',
        kk: 'Cookie саясаты',
        id: 'Kebijakan Cookie',
        de: 'Cookie-Richtlinie'
      }
    },
    copyright: {
      en: 'Miside. All rights reserved.',
      ja: 'Miside. 全著作権所有。',
      ko: 'Miside. 모든 권리 보유.',
      th: 'Miside. สงวนลิขสิทธิ์.',
      es: 'Miside. Todos los derechos reservados.',
      ru: 'Miside. Все права защищены.',
      vi: 'Miside. Tất cả các quyền được bảo lưu.',
      kk: 'Miside. Барлық құқықтар қорғалған.',
      id: 'Miside. Hak cipta dilindungi.',
      de: 'Miside. Alle Rechte vorbehalten.'
    }
  },
  recommendedGames: {
    title: {
      en: 'Recommended Games',
      ja: 'おすすめゲーム',
      ko: '추천 게임',
      th: 'เกมแนะนำ',
      es: 'Juegos Recomendados',
      ru: 'Рекомендуемые игры',
      vi: 'Trò chơi đề xuất',
      kk: 'Ұсынылған ойындар',
      id: 'Game yang Direkomendasikan',
      de: 'Empfohlene Spiele'
    }
  }
} as const;